import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  OnDestroy,
  Output,
  ViewChild
} from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ThemeService } from '../../services/theme/theme.service';
import { ThemeColors } from './theme-colors';

@Component({
  selector: 'pcp-theme-colors',
  templateUrl: './theme-colors.component.html',
  styleUrls: ['./theme-colors.component.scss'],
  standalone: true
})
export class ThemeColorsComponent implements AfterViewInit, OnDestroy {
  constructor(private theme: ThemeService) {
    this.theme.themeChange$.pipe(takeUntil(this.onDestroy$)).subscribe((t) => {
      this.colors.themeStyleChange = this.lastThemeStyle !== t.isDark;
      this.lastThemeStyle = t.isDark;
      this.refreshThemeColors();
    });
  }

  colors = new ThemeColors('', '', '', '', '', '', '', '', '', false);
  lastThemeStyle: boolean | null = null;
  onDestroy$ = new Subject<void>();
  @Output() colorsChange = new EventEmitter<ThemeColors>();

  @ViewChild('primaryTextColorElement')
  primaryTextColorElement: ElementRef<HTMLDivElement> | null = null;
  @ViewChild('secondaryTextColorElement')
  secondaryTextColorElement: ElementRef<HTMLDivElement> | null = null;
  @ViewChild('dividersColorElement')
  dividersColorElement: ElementRef<HTMLDivElement> | null = null;
  @ViewChild('primaryColorElement')
  primaryColorElement: ElementRef<HTMLDivElement> | null = null;
  @ViewChild('primaryLighterColorElement')
  primaryLighterColorElement: ElementRef<HTMLDivElement> | null = null;
  @ViewChild('accentColorElement')
  accentColorElement: ElementRef<HTMLDivElement> | null = null;
  @ViewChild('accentLighterColorElement')
  accentLighterColorElement: ElementRef<HTMLDivElement> | null = null;
  @ViewChild('warnColorElement')
  warnColorElement: ElementRef<HTMLDivElement> | null = null;
  @ViewChild('warnLighterColorElement')
  warnLighterColorElement: ElementRef<HTMLDivElement> | null = null;

  ngAfterViewInit(): void {
    this.refreshThemeColors();
  }

  ngOnDestroy() {
    this.onDestroy$.next();
  }

  refreshThemeColors() {
    setTimeout(() => {
      if (this.secondaryTextColorElement) {
        this.colors.secondaryTextColor = getComputedStyle(
          this.secondaryTextColorElement.nativeElement
        ).color;
      }
      if (this.primaryTextColorElement) {
        this.colors.primaryTextColor = getComputedStyle(
          this.primaryTextColorElement.nativeElement
        ).color;
      }
      if (this.dividersColorElement) {
        this.colors.dividersColor = getComputedStyle(
          this.dividersColorElement.nativeElement
        ).color;
      }
      if (this.primaryColorElement) {
        this.colors.primaryColor = getComputedStyle(
          this.primaryColorElement.nativeElement
        ).color;
      }
      if (this.accentColorElement) {
        this.colors.accentColor = getComputedStyle(
          this.accentColorElement.nativeElement
        ).color;
      }
      if (this.primaryLighterColorElement) {
        this.colors.primaryLighterColor = getComputedStyle(
          this.primaryLighterColorElement.nativeElement
        ).color;
      }
      if (this.accentLighterColorElement) {
        this.colors.accentLighterColor = getComputedStyle(
          this.accentLighterColorElement.nativeElement
        ).color;
      }
      if (this.warnColorElement) {
        this.colors.warnColor = getComputedStyle(
          this.warnColorElement.nativeElement
        ).color;
      }
      if (this.warnLighterColorElement) {
        this.colors.warnLighterColor = getComputedStyle(
          this.warnLighterColorElement.nativeElement
        ).color;
      }
    });

    this.colorsChange.emit(this.colors);
  }
}
